const actions = {
  LOGIN_BEGIN: 'LOGIN_BEGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERR: 'LOGIN_ERR',

  LOGOUT_BEGIN: 'LOGOUT_BEGIN',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_ERR: 'LOGOUT_ERR',

  UPDATE_PASSWORD_DETAILS_BEGIN: 'UPDATE_PASSWORD_DETAILS_BEGIN',
  UPDATE_PASSWORD_DETAILS: 'UPDATE_PASSWORD_DETAILS',
  UPDATE_PASSWORD_DETAILS_ERR: 'UPDATE_PASSWORD_DETAILS_ERR',
  UPDATE_PASSWORD_DETAILS_EMPTY: 'UPDATE_PASSWORD_DETAILS_EMPTY',

  loginBegin: () => {
    return {
      type: actions.LOGIN_BEGIN,
    };
  },

  loginSuccess: (data) => {
    return {
      type: actions.LOGIN_SUCCESS,
      data,
    };
  },

  loginErr: (err) => {
    return {
      type: actions.LOGIN_ERR,
      err,
    };
  },

  logoutBegin: () => {
    return {
      type: actions.LOGOUT_BEGIN,
    };
  },

  logoutSuccess: (data) => {
    return {
      type: actions.LOGOUT_SUCCESS,
      data,
    };
  },

  logoutErr: (err) => {
    return {
      type: actions.LOGOUT_ERR,
      err,
    };
  },

  updatePasswordDetailsBegin: () => {
    return {
      type: actions.UPDATE_PASSWORD_DETAILS_BEGIN,
    };
  },

  updatePasswordDetails: (data) => {
    return {
      type: actions.UPDATE_PASSWORD_DETAILS,
      data,
    };
  },
  updatePasswordDetailsErr: (err) => {
    return {
      type: actions.UPDATE_PASSWORD_DETAILS_ERR,
      err,
    };
  },
  updatePasswordDetailsEmpty: (err) => {
    return {
      type: actions.UPDATE_PASSWORD_DETAILS_EMPTY,
      err,
    };
  },
};

export default actions;
